import { DetailedLoadStatus } from "../../../../../../../common/utils/async-status";
import { NormalizedData } from "../types";

export const FETCH_DECKS_PREFIX = "overleaf/decks/fetch";
export const SET_SELECTED_DECK = "overleaf/local/setSelectedDeckId";
export const FETCH_DECK_PREFIX = "overleaf/deck/fetch";
export const CREATE_DECK_PREFIX = "overleaf/deck/create";
export const UPDATE_DECK_PREFIX = "overleaf/deck/update";
export const DELETE_DECK_PREFIX = "overleaf/deck/delete";

export type DeckData = overleaf.PartialDeck & {
  cards?: string[];
};

export interface DeckState {
  deckData: NormalizedData<DeckData>;
  loadStatus: DetailedLoadStatus;
  selected: string | undefined;
  error?: { name: string; code: string } | null;
}
